import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable, tap } from 'rxjs';
import { LoggerService } from '../services/logger/logger.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../environments/environment';

const UNSAFE_METHODS = ['POST', 'PUT', 'PATCH', 'DELETE'];

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
    private logger = inject(LoggerService);
    private cookieService = inject(CookieService);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let clonedReq = req.clone({
            withCredentials: true,
            setHeaders: { 'Cache-Control': 'no-store, no-cache' },
        });

        if (
            this.isUnsafeMethod(req.method) &&
            this.isApiRequest(req.url) &&
            !req.headers.has('X-XSRF-TOKEN')
        ) {
            const token = this.cookieService.get('XSRF-TOKEN');
            if (token) {
                clonedReq = clonedReq.clone({
                    setHeaders: { 'X-XSRF-TOKEN': token },
                });
            }
        }

        return next.handle(clonedReq).pipe(
            tap({
                error: (error) => {
                    if (error.status === 429) {
                        this.logger.warn('API response status 429: Too Many Requests');
                    }
                },
            }),
        );
    }

    private isUnsafeMethod(method: string): boolean {
        return UNSAFE_METHODS.includes(method.toUpperCase());
    }

    private isApiRequest(url: string): boolean {
        try {
            const baseUrl = new URL(environment.ZCI_API_BASE_URL);
            const requestUrl = new URL(url, baseUrl);
            if (requestUrl.origin !== baseUrl.origin) {
                return false;
            }
            const basePath = baseUrl.pathname.endsWith('/') ? baseUrl.pathname : baseUrl.pathname + '/';
            const requestPath = requestUrl.pathname;
            return requestPath === baseUrl.pathname || requestPath.startsWith(basePath);
        } catch {
            return false;
        }
    }
}
